import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { API_URL, API_URL_UPLOADS } from "../config";
import DashboardLayout from "../../components/DashboardLayout/DasboardLayout";

const PendingReg = () => {
  const [pendingVerifications, setPendingVerifications] = useState([]);
  const [vehicleData, setVehicleData] = useState({});
  const APILINK = API_URL;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    Modal.setAppElement(".min-h-screen");
    handleSearch();
    const interval = setInterval(handleSearch, 7000);
    return () => clearInterval(interval);
  }, []);

  const openModal = (image) => {
    if (image) {
      setSelectedImage(`${API_URL_UPLOADS}/${image}`);
      setModalIsOpen(true);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImage("");
  };

  const fetchUserData = async (status) => {
    try {
      const response = await fetch(`${APILINK}/driver/driver_status/${status}`);
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch user data:", error);
      throw error;
    }
  };

  const fetchVehicleData = async (driverId) => {
    try {
      const response = await fetch(
        `http://localhost:3011/vehicle/getvehiclesbydriverid/${driverId}`
      );
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const vehicles = await response.json();
      setVehicleData((prevData) => ({
        ...prevData,
        [driverId]: vehicles,
      }));
    } catch (error) {
      console.error("Failed to fetch vehicle data:", error);
    }
  };

  const handleSearch = async () => {
    try {
      const status = "Pending Verification";
      const pending = await fetchUserData(status);
      setPendingVerifications(pending);
      pending.forEach((verification) => {
        fetchVehicleData(verification.driver_id);
      });
    } catch (error) {
      console.error("Error in handleSearch:", error);
      setPendingVerifications([]);
    }
  };

  const updateUserStatus = async (driverId, status) => {
    try {
      const response = await fetch(
        `${APILINK}/driver/update_status/${driverId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ membershipstatus: status }),
        }
      );

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      await fetch(`${APILINK}/users/update_status/${driverId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      });

      handleSearch();
    } catch (error) {
      console.error(`Failed to update user status to ${status}:`, error);
    }
  };

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-white text-white">
        <div className="container mx-auto px-4 py-8">
          <h1 className="text-4xl font-bold mb-8 text-center text-[#002966]">
            Driver Verification Portal
          </h1>

          {pendingVerifications.length > 0 ? (
            <div className="space-y-8">
              {pendingVerifications.map((verification) => (
                <div
                  key={verification.driver_id}
                  className="bg-gradient-to-b from-[#002966] to-[#001a4d] rounded-xl p-6 shadow-xl border border-white/20"
                >
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-2xl font-semibold text-[#ffc000]">
                      Pending Verification
                    </h3>
                    <span className="bg-[#ffc000] text-[#002966] px-4 py-1 rounded-full text-sm font-bold">
                      ID: {verification.driver_id}
                    </span>
                  </div>

                  <div className="bg-white/5 rounded-lg p-4 mb-6">
                    <h4 className="text-lg font-semibold mb-4 text-[#ffc000]">
                      Verification Documents
                    </h4>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                      {[
                        "profilePic",
                        "driver_license_image",
                        "id_image",
                        "vehicle_license_image",
                        "number_plate_image",
                      ].map(
                        (imageKey) =>
                          verification[imageKey] && (
                            <div className="relative group" key={imageKey}>
                              <img
                                src={`${API_URL_UPLOADS}/${verification[imageKey]}`}
                                alt={imageKey.replace(/_/g, " ")}
                                onClick={() =>
                                  openModal(verification[imageKey])
                                }
                                className="w-full h-32 object-cover rounded-lg cursor-pointer transition-transform transform hover:scale-105"
                              />
                              <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-white text-xs py-1 px-2 rounded-b-lg">
                                {imageKey.replace(/_/g, " ")}
                              </div>
                            </div>
                          )
                      )}
                    </div>
                  </div>

                  <h4 className="text-lg font-semibold text-[#ffc000] mt-4">
                    Vehicle Images
                  </h4>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                    {["vehicle_image1", "vehicle_image2", "vehicle_image3"].map(
                      (imgKey) =>
                        vehicleData[verification.driver_id]?.[0][imgKey] && (
                          <div className="relative group" key={imgKey}>
                            <img
                              src={`${API_URL_UPLOADS}/${
                                vehicleData[verification.driver_id][0][imgKey]
                              }`}
                              alt={imgKey.replace(/_/g, " ")}
                              onClick={() =>
                                openModal(
                                  vehicleData[verification.driver_id][0][imgKey]
                                )
                              }
                              className="w-full h-32 object-cover rounded-lg cursor-pointer transition-transform transform hover:scale-105"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-white text-xs py-1 px-2 rounded-b-lg">
                              {imgKey.replace(/_/g, " ")}
                            </div>
                          </div>
                        )
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className="space-y-4">
                      <h4 className="text-lg font-semibold text-[#ffc000]">
                        Basic Information
                      </h4>
                      <div className="space-y-2">
                        {[
                          {
                            label: "Name",
                            value: `${verification.name}${verification.surname}`,
                          },
                          { label: "Email", value: verification.email },
                          { label: "Phone", value: verification.phone },
                          { label: "Date of Birth", value: verification.dob },
                          { label: "Username", value: verification.username },
                          { label: "Sex", value: verification.sex },
                          { label: "Role", value: verification.account_type },
                          { label: "email", value: verification.email },
                        ].map((item) => (
                          <div
                            key={item.label}
                            className="flex justify-between items-center bg-white/5 p-3 rounded"
                          >
                            <span className="text-gray-300">{item.label}:</span>
                            <span className="font-medium">{item.value}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="space-y-4">
                      <h4 className="text-lg font-semibold text-[#ffc000]">
                        Vehicle Information
                      </h4>
                      <div className="space-y-2">
                        {vehicleData[verification.driver_id]?.map((vehicle) => (
                          <React.Fragment key={vehicle.vehicles_id}>
                            {[
                              {
                                label: "Vehicle Make",
                                value: vehicle.vehicle_make,
                              },
                              {
                                label: "Vehicle Model",
                                value: vehicle.vehicle_model,
                              },
                              { label: "Colour", value: vehicle.colour },
                              { label: "Year", value: vehicle.vehicle_year },
                              {
                                label: "Vehicle Type",
                                value: vehicle.vehicle_type,
                              },
                              {
                                label: "Number Plate",
                                value: vehicle.number_plate,
                              },
                              {
                                label: "Vehicle Category",
                                value: vehicle.vehicle_category,
                              },
                              {
                                label: "Delivery Volume",
                                value: vehicle.delivery_volume || "N/A",
                              },
                              {
                                label: "Delivery Weight",
                                value: vehicle.delivery_weight || "N/A",
                              },
                            ].map((item) => (
                              <div
                                key={item.label}
                                className="flex justify-between items-center bg-white/5 p-3 rounded"
                              >
                                <span className="text-gray-300">
                                  {item.label}:
                                </span>
                                <span className="font-medium">
                                  {item.value}
                                </span>
                              </div>
                            ))}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="mt-8 flex gap-4">
                    <button
                      onClick={() =>
                        updateUserStatus(verification.driver_id, "Verified")
                      }
                      className="flex-1 bg-[#ffc000] text-[#002966] py-3 rounded-lg font-bold hover:bg-[#ffcd33] transition-colors"
                    >
                      Verify Driver
                    </button>
                    <button
                      onClick={() =>
                        updateUserStatus(verification.driver_id, "Rejected")
                      }
                      className="flex-1 border-2 border-[#ffc000] text-[#002966] py-3 rounded-lg font-bold hover:bg-[#ffc000] hover:text-[#002966] transition-colors"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-xl text-gray-300">
                No pending verifications found.
              </p>
            </div>
          )}

          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Image Preview"
            className="max-w-4xl mx-auto mt-20 bg-[#002966] rounded-lg overflow-hidden"
            overlayClassName="fixed inset-0 bg-black/80 flex items-center justify-center"
          >
            <div className="relative">
              <img
                src={selectedImage}
                alt="Preview"
                className="w-full h-auto max-h-[80vh] object-contain"
              />
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
              >
                Close
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PendingReg;
